export default __webpack_public_path__ + "static/media/user.b069e72e.svg";